import React, { memo } from 'react';
import { CheckIcon } from '../Icons';
import { classNames } from '../../utils/classNames';
import type { CommentSubmitButtonsProps } from './CommentSubmitButtons.types';
import './CommentSubmitButtons.css';

const CommentSubmitButtonsComponent: React.FC<CommentSubmitButtonsProps> = ({
  onCancel,
  onSubmit,
  className
}) => {
  const handleCancel = (event: React.MouseEvent) => {
    event.stopPropagation();
    onCancel();
  };

  const handleSubmit = (event: React.MouseEvent) => {
    event.stopPropagation();
    onSubmit();
  };

  return (
    <div className={classNames('comment-submit-buttons', className)}>
      <button
        type="button"
        className="comment-submit-buttons__cancel"
        onClick={handleCancel}
        aria-label="Cancel edit"
      >
        Cancel
      </button>
      <button
        type="button"
        className="comment-submit-buttons__submit"
        onClick={handleSubmit}
        aria-label="Submit changes"
      >
        <CheckIcon />
      </button>
    </div>
  );
};

export const CommentSubmitButtons = memo(CommentSubmitButtonsComponent);
